import BaseComponent from '../../../base/base_component';
import Directive from '../../../core/directive';
import Event from '../../../utils/event';
import DOM from '../../../utils/dom';
import {FP_MESSAGE_MODE} from '../../../services/free_play/free_play_consts';
import {PRIORITY_LEVEL} from '../../../services/overlay_manager/overlay_manager_levels';
import {SYSTEM_EVENTS} from '../../../events/events';
import {GAME_SOURCE} from '../navbar_const';
import {DEEP_LINK_MAP} from '../../external_links/handlers/external_links_base_handler_consts';
import {FP_MESSAGE_DATA} from '../navbar_const';
import { FREE_PLAY_FILTER_CONSTRAINTS } from '../../free_play/indicator/fp_indicator_consts';

let freePlayIndicatorHtml = require('../view/free-play-indicator.html');

export default class FreePlayIndicatorNavbarPart extends BaseComponent {
    static CLASS = 'FreePlayIndicatorNavbarPart';

    init(params) {
        this._selector = '';
        super.init(params);
        this._gameType = params.gameType;
        this._freePlayData = params.freePlayData;
        this._referrerId = params.referrerId;

        this.setInnerHtml(this.bake(freePlayIndicatorHtml));
        this.addClass('cgp-navbar-fp-indicator');

        this._createFreePlayIndicator();
        this._subscribe();

    }

    _getIsolationSelector() {
        return '';
    }

    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.FREE_PLAY_OPEN_INTERNAL_VOUCHERS_MESSAGE, (params) => {
            this._openFreePlayDirective(params);
        });
    }

    _createFreePlayIndicator() {
        let props = {
            indicatorIcons: {
                enabled: 'cgp-themes-icons-game-frame-fp-indicator',
                selected: 'cgp-theme-property-icons-fp-selected',
                disabled: 'hide'
            },
            openMode: FP_MESSAGE_MODE.EMBEDDED_INTERNAL,
            displayConstraint: FREE_PLAY_FILTER_CONSTRAINTS.CONTAINS_GAME,
            gameTypeID: this._gameType,
            freePlayID: this._freePlayData && this._freePlayData.freePlayId,
            openPriority: PRIORITY_LEVEL.GAME_FRAME_FP,
            openDirection: 'vertical',
            onSelected: (isSelected) => {
                if (false === isSelected) {
                    DOM.removeClass(document.querySelector('.cgp-game-window-navigation-panel'), 'cgp-navbar-fp-message');
                    this.removeChildComponent(this._fpMessage);
                    this._fpMessage = null;
                } else {
                    Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_FreePlay', action: 'GameFrame', label: 'FreePlayIcon'});
                }
            }
        };
        this._fpIndicator = Directive.generate({directiveName: 'fp_indicator', start: true, props: props});
        this.appendChildComponent(this._fpIndicator);
        this._fpIndicator.onAppendedToDOM();
    }

    _openFreePlayDirective(params) {
        // Set timeout prevents creation of the directive, so the directive will be created after execution of this._fpIndicator ONCLICK handler
        setTimeout(() => {
            let gameSource = this._getGameReferrer();
            if (gameSource) { // check if the game is opened from challenges
                params = Object.assign({}, params, {allowOpenGameFn: this._handleFPOpenGame.bind(this, gameSource)})
            }
            this._fpMessage = Directive.generate({directiveName: 'free_play', start: true, props: params});
            this.appendChildComponent(this._fpMessage, '.cgp-navbar-fp-inner-wrapper');
            DOM.addClass(document.querySelector('.cgp-game-window-navigation-panel'), 'cgp-navbar-fp-message');
            this._fpMessage.onAppendedToDOM();
        }, 100);
    }

    _getGameReferrer() {
        if (this._referrerId === DEEP_LINK_MAP.MY_ACCOUNT_DL_MY_CHALLENGES) {
            return GAME_SOURCE.CHALLENGES;
        }

        return null;
    }

    _handleFPOpenGame(source) {
        return new Promise((res, rej) => {
            let langService = this.serviceFactory.languageService();
            //let msgParams = this._getFPMessageParams('', res, rej);
            Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
                closeButton: false,
                hasDefaultButton: false,
                text: langService.translation(FP_MESSAGE_DATA[source].content),
                buttons: [
                    {
                        type: 'main',
                        name: langService.translation(FP_MESSAGE_DATA[source].ctaOK),
                        callback: () => {
                            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, FP_MESSAGE_DATA[source].analytics.ctaOK);
                            res();
                        },
                        // forceAnalytic: true
                    },
                    {
                        type: 'secondary',
                        name: langService.translation(FP_MESSAGE_DATA[source].ctaCancel),
                        callback: () => {
                            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, FP_MESSAGE_DATA[source].analytics.ctaCancel);
                            if(this._fpIndicator) {
                                this._fpIndicator.getEl().click();
                            }
                            rej();
                        },
                        forceAnalytic: true
                    }
                ]
            });
        });
    }
}